define([
  'js/aofl-js/0.8.0/app/app',
  'text!readingiq-src/js/comprehension-check-js/placement-validate-modal/1.0.0/index.html',
  'text!readingiq-src/js/comprehension-check-js/placement-validate-modal/1.0.0/index.css',
  'js/aofl-js/0.8.0/aofl-modules/__build/aofljs.min',
  'readingiq-src/js/riq-js/info-message-modal/1.0.0/index',
  'readingiq-src/js/riq-js/riq-spinner/1.0.0/index',
  'readingiq-src/js/comprehension-check-js/placement-validate-model-service/1.0.0/index'
], function placementValidateModalModule(app, html, css, aoflModules) {
  'use strict';
  var storeService = aoflModules.store;

  app.registerComponent('placementValidateModal', {
    bindings: {
      placementState: '<',
      startPlacement: '&',
      submitForm: '&'
    },
    controller: 'placementValidateModalController',
    template: html
  });

  app.registerController('placementValidateModalController', [
    '$state',
    '$scope',
    '$element',
    'placementModelService',
    'ngDialog',
    'compileService',
    function placementValidateModalController(
      $state,
      $scope,
      $element,
      placementModelService,
      modalService,
      compileService
    ) {
      var _this = this;
      var setActiveAsmtLevel = placementModelService.setActiveAsmtLevel;

      var openModal = function openModal() {
        modalService.open({
          template: 'placementValidateModal',
          disableAnimation: true,
          preserveFocus: false,
          trapFocus: true,
          className: 'ngdialog-theme-default placementValidateModal',
          closeByNavigation: false,
          closeByEscape: false,
          closeByDocument: false,
          scope: $scope,
          controller: 'InfoMessageModalController',
          controllerAs: 'infoMessageModalCtrl'
        });
      };

      _this.closeModal = function closeModal() {
        modalService.closeAll();
      };

      _this.onPlacementStart = function onPlacementStart() {
        _this.closeModal();
        _this.startPlacement();
      };

      _this.updateShelf = function updateShelf() {
        _this.closeModal();
        setActiveAsmtLevel({
          profileUuid: _this.profileUuid,
          gradeLevel: _this.newGradeLevel
        }).then(function() {
          _this.submitForm();
        });
      };

      var mapProperties = function mapProperties() {
        var state = storeService.getState();
        _this.childName = state.riqChildForm.name;
        _this.newGradeLevel = state.riqChildForm.levelId;
        _this.levelLabel = state.riqChildForm.levelLabel;
        _this.profileUuid = state.riqChildForm.profileUuid;
        _this.isActiveUser =
          $state.params.profile === state.profile.profileUuid;
        openModal();
      };

      var onInit = function onInit() {
        mapProperties();
      };

      onInit();

      _this.$onDestroy = function onDestroy() {
        modalService.closeAll();
      };

      compileService.compile(
        {
          css: css
        },
        $scope,
        $element
      );
    }
  ]);
});
